import { render, staticRenderFns } from "./OrganizationMapPreviewBig.vue?vue&type=template&id=4f873ea9&"
import script from "./OrganizationMapPreviewBig.vue?vue&type=script&lang=ts&"
export * from "./OrganizationMapPreviewBig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports